import React from 'react';
import { motion } from 'framer-motion';
const steps = [{
  num: '01',
  title: 'Identifica',
  desc: 'Detectas las señales de bloqueo que emites actualmente con nuestra guía de autoevaluación.'
}, {
  num: '02',
  title: 'Ajusta',
  desc: "Implementas micro-movimientos de 'Estatus Relajado' que cambian tu química interna y tu proyección externa."
}, {
  num: '03',
  title: 'Atrae',
  desc: 'Observas cómo el entorno reacciona a tu nueva frecuencia, permitiendo que los hombres tomen la iniciativa.'
}];
export function HowItWorks() {
  return <section className="py-24 px-6 bg-darker" data-id="element-77">
      <div className="max-w-5xl mx-auto" data-id="element-78">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="text-center mb-16" data-id="element-79">
          <h2 className="font-serif text-3xl md:text-4xl text-cream" data-id="element-80">
            Cómo Funciona
          </h2>
          <div className="w-24 h-px bg-gold mx-auto mt-6 opacity-50" data-id="element-81"></div>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-8 relative" data-id="element-82">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-12 left-[15%] right-[15%] h-px bg-gold/20 z-0" data-id="element-83"></div>

          {steps.map((step, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.6,
          delay: i * 0.2
        }} className="relative z-10 flex flex-col items-center text-center" data-id="element-84">
              <div className="w-24 h-24 rounded-full bg-dark border border-gold/30 flex items-center justify-center mb-6 shadow-[0_0_30px_rgba(201,168,76,0.1)]" data-id="element-85">
                <span className="font-serif text-3xl text-gold" data-id="element-86">
                  {step.num}
                </span>
              </div>
              <h3 className="font-serif text-2xl text-cream mb-4" data-id="element-87">
                {step.title}
              </h3>
              <p className="font-sans text-cream/70 font-light leading-relaxed px-4" data-id="element-88">
                {step.desc}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}